var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.selectedValue,
          expression: "selectedValue",
        },
      ],
      staticClass: "form-control",
      on: {
        change: function ($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function (o) {
              return o.selected
            })
            .map(function (o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.selectedValue = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        },
      },
    },
    _vm._l(_vm.options, function (option) {
      return _c("option", { key: option.id, domProps: { value: option.id } }, [
        _vm._v("\n        " + _vm._s(option.text) + "\n    "),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }